import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';

@NgModule({
    declarations: [
        LandingPageComponent
    ],
    imports: [
        CommonModule
    ]
})
export class LandingModule {
}
